import React from 'react';
import styled from 'styled-components';

const MobileStaffExperience: React.FC = () => (
  <PageWrapper>
    <PageTitle>Staff / Superuser Mobile</PageTitle>
    <PageText>
      This is the mobile experience for staff and superusers. Access admin utilities, reports, and elevated tools while on mobile.
    </PageText>
  </PageWrapper>
);

export default MobileStaffExperience;

const PageWrapper = styled.div`
  display: grid;
  gap: 16px;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  margin: 0;
  color: #111827;
`;

const PageText = styled.p`
  font-size: 16px;
  color: #475569;
  line-height: 1.6;
`;
